import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cva } from "class-variance-authority";
import { cn } from "../../../utils";
const avatarVariants = cva("relative flex shrink-0 overflow-hidden", {
    variants: {
        size: {
            xs: "h-6 w-6 rounded-lg",
            sm: "h-8 w-8 rounded-lg",
            default: "h-9 w-9 rounded-lg",
            md: "h-12 w-12 rounded-lg",
            lg: "h-24 w-24 rounded-full"
        }
    },
    defaultVariants: {
        size: "default"
    }
});
const Avatar = /*#__PURE__*/ React.forwardRef(({ className, size, ...props }, ref)=>/*#__PURE__*/ _jsx(AvatarPrimitive.Root, {
        ref: ref,
        className: cn(avatarVariants({
            size
        }), className),
        ...props
    }));
Avatar.displayName = AvatarPrimitive.Root.displayName;
const AvatarImage = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(AvatarPrimitive.Image, {
        ref: ref,
        className: cn("aspect-square h-full w-full", className),
        ...props
    }));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
const AvatarFallback = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(AvatarPrimitive.Fallback, {
        ref: ref,
        className: cn("flex h-full w-full items-center justify-center bg-muted", className),
        ...props
    }));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
export { Avatar, AvatarImage, AvatarFallback };

//# sourceMappingURL=avatar.js.map